module.exports = __webpack_public_path__ + "img/pn.pn7140325.svg";